import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

/**
 * Vangt een mislukte modelbelading af.
 *
 * Een React-foutgrens is hier de enige manier: `useGLTF` gooit zijn fout tijdens
 * het renderen (via Suspense), niet in een promise die je kunt afvangen. Zonder
 * dit valt bij één ontbrekend of kapot bestand de hele kiosk om — en dat op een
 * scherm dat drie dagen onbemand moet draaien.
 */
export class Foutgrens extends Component<
  { kind: ReactNode; terugval: ReactNode; onFout?: (f: Error) => void },
  { fout: Error | null }
> {
  state = { fout: null as Error | null }

  static getDerivedStateFromError(fout: Error) {
    return { fout }
  }

  componentDidCatch(fout: Error, info: ErrorInfo) {
    // Bewust naar de console: bij een storing op de beurs is dit het eerste wat
    // iemand openslaat, en de sourcemaps staan aan (vite.config.ts).
    console.error('[productviewer] model laden mislukt', fout, info.componentStack)
    this.props.onFout?.(fout)
  }

  render() {
    return this.state.fout ? this.props.terugval : this.props.kind
  }
}
